import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 3l0 7l6 0l-8 11l0 -7l-6 0l8 -11","key":"svg-0"}]]

const IconBolt = createReactComponent('outline', 'bolt', 'Bolt', __iconNode);

export default IconBolt;